import { getAdGroupSelectOptions } from 'app/sponsoredAds/services/servicesSponsoredAds';
import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import remoteOptionSelectFactory from './remoteOptionSelectFactory';
import withInputErrorMessage from '../withInputErrorMessage';
import withSelectFormik from './withSelectFormik';

export default withSelectFormik(withInputErrorMessage(remoteOptionSelectFactory({
   getSuggestionsPromise: getAdGroupSelectOptions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndIdAsValueAndNameAsLabel,
})));
